export const getIndustryDisplayName = (
  industryValue: string,
  industryMap: Record<string, string>
) => {
  if (!industryValue) {
    return industryValue
  }
  const [, ...secondaryParts] = industryValue.split('-')
  const secondaryIndustry = secondaryParts.length > 0 ? secondaryParts.join('-') : industryValue
  return industryMap[secondaryIndustry] || secondaryIndustry
}

